import { render, staticRenderFns } from "./SurveyViewer.vue?vue&type=template&id=3af92978&"
import script from "./SurveyViewer.vue?vue&type=script&lang=js&"
export * from "./SurveyViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports